import React, { Component, type ReactNode } from "react";
import { connect } from "react-redux";
import { Link, type RouteComponentProps } from "react-router-dom";
import { Button } from "reactstrap";
import { bindActionCreators } from "redux";
import { LIST_CREATE_VIEW_PATH } from "./CreateListView";
import { Breadcrumbs } from "src/app/layout/Breadcrumbs";
import { ContentHeader } from "src/app/ui/authenticated/ContentHeader";
import { ContentHeaderControls } from "src/app/ui/authenticated/ContentHeaderControls";
import { ContentHeading } from "src/app/ui/authenticated/ContentHeading";
import { GetLists } from "src/lists/actions/ListActionCreators";
import ListTable from "src/lists/components/ListTable";
import { ListCreate, ListsLabel } from "src/lists/formatters/ListFormatters";
import type { List, ListStatus } from "src/lists/objects/List";
import { ManageLabel } from "src/manage/ManageFormatters";
import Loader from "src/shared/components/Loader";

export const LISTS_VIEW_PATH: string = "/ls";

interface IListsViewInnerProps extends IListsViewProps {
  GetLists: (status?: ListStatus) => Promise<List[]>;
}
interface IListsViewInnerState {
  promise: Promise<List[]> | undefined;
}

class ListsViewInner extends Component<
  IListsViewInnerProps,
  IListsViewInnerState
> {
  public state = {
    promise: undefined,
  };

  public componentDidMount(): void {
    this.onLoad();
  }

  public onLoad = () => {
    const { GetLists } = this.props;
    this.setState({
      promise: GetLists(),
    });
  };

  public render(): ReactNode {
    const { children } = this.props;
    const { promise } = this.state;

    return (
      <>
        <ContentHeader>
          <Breadcrumbs
            levels={[<ManageLabel key={0} hasLink />, <ListsLabel key={1} />]}
          />

          <ContentHeaderControls>
            <Button tag={Link} to={LIST_CREATE_VIEW_PATH} color="info">
              <ListCreate />
            </Button>
          </ContentHeaderControls>

          <ContentHeading>
            <h2>
              <ListsLabel />
            </h2>
          </ContentHeading>
        </ContentHeader>

        <Loader promise={promise}>
          {(lists: List[]) => (
            <>
              {children && children(lists, this.onLoad)}

              <ListTable>{lists}</ListTable>
            </>
          )}
        </Loader>
      </>
    );
  }
}

// Bind with Redux.
export interface IListsViewProps extends RouteComponentProps<any> {
  children?: (lists: any[], onLoad: () => void) => ReactNode;
}
export default connect(
  () => {
    return {};
  },
  (dispatch) =>
    bindActionCreators(
      {
        GetLists,
      },
      dispatch,
    ),
)(ListsViewInner);
